import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import profileImage1 from 'assets/images/profile-image-1.png';
import profileImage2 from 'assets/images/Shivani.jpg';
import lineBulb from 'assets/images/line-bulb.png';
import worldMap from 'assets/images/world-map.png';
import HeroSection from 'components/common/sections/HeroSection';
import TryDemoSection from 'components/common/sections/TryDemoSection';
import FAQSection from 'components/common/sections/FAQSection';
import './AboutUs.css';


function AboutUs() {

  return (
    <>
      {/* Hero section */}
      <HeroSection showVideo={false} additionalCol={
        <Col className="col-12 text-center my-auto mb-lg-auto mt-4">
          {/*<h4 className="mb-4 mt-4">Team</h4>*/}
          <h1 className="mb-5">WHO WE ARE</h1>
        </Col>
      }/>

      {/* Founder section */}
      <section id="founder-section">
        <Container fluid className="mb-5 mt-5 text-center text-lg-start">
          <Row>
            <Col sm={1} lg={2} className="d-none d-lg-block"></Col>
            <Col sm={12} lg={5}
                 className="d-flex align-items-center justify-content-center text-left pt-5 p-3 p-lg-5 bg-white">
              <div>
                <h2>Siddharth Goyal</h2>
                <h4 style={{color: "#000000aa", marginTop: "10px"}}>Founder</h4>
                <p style={{color: "#000000cc", marginBottom: "30px"}}>
                  Siddharth is the driving force behind our
                  innovative approach to investing and trading. With a strong background in coding,
                  statistical inquiry, and data science, Siddharth leverages his expertise to build
                  robust quantitative models across various asset classes. His extensive experience in
                  trading and investing for private individuals adds depth to his strategic
                  decision-making. As the founder, Siddharth's visionary leadership and deep market
                  knowledge guide our company towards delivering cutting-edge solutions and achieving
                  success in the dynamic world of trading and investing.
                  {/*As a Founder and Owner of Fort InvesTech, Siddharth has shaped the automated wealth management*/}
                  {/*firm into what it is today. Prior to this, he was a spot forex trader and has 17+ years of*/}
                  {/*experience in the field. He is highly skilled at statistical evaluation and drives the firm’s*/}
                  {/*growth efforts. At other times, he always loves learning to code more.*/}
                </p>
              </div>
            </Col>
            <Col sm={12} lg={5} className="px-0 d-flex flex-column bg-white">
              <div className="flex-grow-1 text-center">
                <img className="img-fluid p-4" src={profileImage1} alt=""/>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Co Founder section */}
      <section id="co-founder-section">
        <Container fluid className="mb-5 mt-5 text-center text-lg-start">
          <Row>
            <Col sm={12} lg={5} className="text-center order-2 order-lg-1 d-flex flex-column bg-white">
              <div className="flex-grow-1 text-center">
                <img className="img-fluid m-4" style={{borderRadius: "8px"}} src={profileImage2}
                     alt=""/>
              </div>
            </Col>
            <Col sm={12} lg={5}
                 className="d-flex align-items-center justify-content-center order-1 order-lg-2 text-left p-5 bg-white">
              <div>
                <h2>Shivani Goyal</h2>
                <h4 style={{color: "#000000aa", marginTop: "10px"}}>Co-Founder</h4>
                <p style={{color: "#000000cc", marginBottom: "30px"}}>
                  Certified CA, CPA US, and ISCA Singapore.
                  Years at PwC optimizing processes, reducing costs, and providing tax planning for
                  multinational
                  corporates.
                  A detail-oriented auditor with a knack for accuracy and compliance.
                  Recognizes growth opportunities through effective tax strategies.
                  Streamlines operations, increases productivity, and drives profitability.
                  A trusted financial expert delivering comprehensive solutions for success.
                  {/*/!*Shivani Goyal - Co-founder and Financial Innovator:*!/*/}
                  {/*Co-founder of Fort invesTech,*/}
                  {/*Shivani Goyal plays a pivotal*/}
                  {/*role in shaping the future of the company. With extensive certifications*/}
                  {/*and a background in process optimization and tax planning,*/}
                  {/*Shivani prioritizes client interests, ensuring their funds*/}
                  {/*remain in their own brokerage accounts.*/}
                  {/*Her innovative mindset and dedication to empowering clients*/}
                  {/*position her as a driving force behind our commitment to financial excellence.*/}
                  {/*Shivani's expertise and vision propel our company forward, revolutionizing the industry and*/}
                  {/*delivering unparalleled investment solutions.*/}
                  {/*The Co-Founder and Owner of Fort InvesTech, Shivani is a finance professional with 18+ years in*/}
                  {/*finance. A CA(India), CPA(US), and CA (Singapore), she has a diverse background on many aspects*/}
                  {/*of finance with multinationals and has been focused on converting improvements in technology into*/}
                  {/*better financial decisions.*/}
                </p>
              </div>
            </Col>
            <Col sm={1} lg={2} className="d-none d-lg-block order-3"></Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Our Mission section */}
      <section id="our-mission-section" style={{marginBottom: "0"}}>
        <Container>
          <Row className="justify-content-center align-items-center" style={{minHeight: "400px"}}>
            <Col sm={12} lg={10} xl={8} className="text-center">
              <h2 className="mb-4">We Make It Our Mission</h2>
              <p className="large-p mb-4" style={{color: "#000000aa"}}>
                Being the companion on clients investment journey. Keeping you on track with your
                investing
                decisions.
                Help clients reclaim their time and pursue the important things in life. Automated
                investing to help clients reach their investment goals without watching a screen.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Thought section */}
      <section id="thought-section">
        <Container fluid className="text-center text-lg-start">
          <Row>
            <Col sm={12} lg={5} className="order-2 order-lg-1 px-0 d-flex flex-column">
              <div className="flex-grow-1 text-center">
                <img className="img-fluid" src={lineBulb} alt=""/>
              </div>
            </Col>
            <Col sm={12} lg={6}
                 className="order-1 order-lg-2m-auto d-flex align-items-center justify-content-center text-left p-4 white-card">
              <div>
                <h2>It All Started With A Thought</h2>
                <p style={{color: "#000000cc", marginBottom: "30px"}}>
                  In 2012, Siddharth (Goyal), an active spot forex trader, realized that manual /
                  discretionary
                  trading or investing is fraught with far too many challenges for a normal
                  hardworking individual
                  to handle – there is an overload of information and too many emotions get involved
                  that prevent
                  optimal decision making.
                </p>
                <h4 style={{display: "inline-flex"}}>
                  Read more
                  <i className="bi bi-arrow-right-circle ml-4"
                     style={{fontSize: "1.5rem", marginLeft: "15px"}}></i>
                </h4>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Plan section */}
      <section id="plan-section">
        <Container fluid className="text-center text-lg-start">
          <Row>
            <Col sm={12} lg={6}
                 className="m-auto d-flex align-items-center justify-content-center text-left p-4 white-card">
              <div>
                <h2>Our Plan For Our Future</h2>
                <p style={{color: "#000000cc", marginBottom: "30px"}}>
                  To be a trusted partner for our clients and a respected leader in global wealth
                  generation.
                  Fort lnvestech was conceptualized to fill in the unmet needs of clients to trade and
                  invest in
                  worldwide markets, with efficient returns on time.
                </p>
                <h4 style={{display: "inline-flex"}}>
                  Read more
                  <i className="bi bi-arrow-right-circle ml-4"
                     style={{fontSize: "1.5rem", marginLeft: "15px"}}></i>
                </h4>
              </div>
            </Col>
            <Col sm={12} lg={5} className="px-0 d-flex flex-column">
              <div className="flex-grow-1 text-center">
                <img className="img-fluid" src={worldMap} alt=""/>
              </div>
            </Col>
          </Row>
        </Container>

      </section>
      {/* End */}

      {/* FAQ section */}
      <FAQSection/>

      {/* Try CTA section */}
      <TryDemoSection/>
    </>
  );

}

export default AboutUs;